export default "/_next/static/chunks/2294472375_24a3b8ef46_o.jpg.f98b93fae8690ffdf0326b0ee7095867.chunk";